import { FC } from "react";

import __ from "web/Layout/Translations";

import TooltipIcon from "web/assets/icons/tooltip.svg";

import defaultClasses from "./toolTip.scss";
import WcagTooltipWrapper from "./wcagTooltipWrapper";

type VariantType = "top" | "right" | "bottom" | "left" | "top-left";
interface IToolTip {
  id?: string;
  message: string | React.ReactNode;
  customStyles?: {
    root?: string;
    message?: string;
    tooltip?: string;
  };
  variant?: VariantType;
  isWCAG?: boolean;
  withoutIcon?: boolean;
}

const ToolTip: FC<IToolTip> = ({
  id = "tooltip-id",
  message,
  customStyles = {},
  variant,
  isWCAG = false,
  withoutIcon = false,
}: IToolTip) => {
  const messageVariant =
    variant && variant !== "top" ? defaultClasses[`message__${variant}`] : "";

  const messageClasses = `${defaultClasses.message} 
  ${customStyles.message ?? ""} 
  ${messageVariant}`;

  const tooltipClasses = {
    root: `${defaultClasses.root} ${customStyles.root ?? ""}`,
    tooltip: `${defaultClasses.tooltip} ${customStyles.tooltip} ${
      isWCAG ? defaultClasses.tooltipWCAG : ""
    }`,
    message: messageClasses,
  };

  return (
    <div className={tooltipClasses.root}>
      {isWCAG ? (
        <WcagTooltipWrapper
          renderTrigger={({ isOpen, ...triggerProps }) => (
            <button
              type="button"
              className={tooltipClasses.tooltip}
              aria-describedby={id}
              aria-expanded={isOpen}
              aria-label={__(message as string)}
              {...triggerProps}
            >
              <TooltipIcon aria-hidden="true" focusable="false" />
            </button>
          )}
          renderTooltip={(isOpen) => (
            <div
              id={id}
              role="tooltip"
              className={`${tooltipClasses.message} ${
                isOpen ? defaultClasses.isVisible : ""
              }`}
            >
              {message}
            </div>
          )}
        />
      ) : (
        <div className={tooltipClasses.tooltip}>
          {!withoutIcon && <TooltipIcon />}
          <div className={tooltipClasses.message} role="tooltip">
            {message}
          </div>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
